import { TableDefinition } from "features/shared/types/table";
import { Product } from "../types/product";

const PRODUCT_TABLE: TableDefinition<Product> = {
    rowTemplate: [
        {
            header: "PRODUCT NO.",
            accessor: "id",
            flex: 2.5,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Name (EN)",
            accessor: "properties:name:en",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Name (TH)",
            accessor: "properties:name:th",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "View Count",
            accessor: "properties:viewCount",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Unit (EN)",
            accessor: "properties:qtyUnit:en",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Unit (TH)",
            accessor: "properties:qtyUnit:th",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Rank",
            accessor: "properties:rank",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Category Rank",
            accessor: "properties:categoryRank",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "SEO",
            accessor: "properties:seo",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Description (EN)",
            accessor: "properties:description:en",
            flex: 3,
            isShown: true,
            minCellWidth: 400,
        },
        {
            header: "Description (TH)",
            accessor: "properties:description:th",
            flex: 3,
            isShown: true,
            minCellWidth: 400,
        },
        {
            header: "Image",
            accessor: "properties:image",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
    ],
    defaultSortKey: "id",
};

export default PRODUCT_TABLE;
